import { render, staticRenderFns } from "./BuyBoxQualityTVNew.vue?vue&type=template&id=92275eda&scoped=true"
import script from "./BuyBoxQualityTVNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxQualityTVNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxQualityTVNew.vue?vue&type=style&index=0&id=92275eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92275eda",
  null
  
)

export default component.exports